import React from 'react';
import styled from 'styled-components/macro';

export const Row = styled.div<{ negativeMarginBottom?: boolean }>`
  display: flex;
  margin-bottom: ${(props) => (props.negativeMarginBottom ? '-18px' : '16px')};
  padding: 0 16px;
  flex-wrap: wrap;

  > * {
    margin-right: 16px;
    margin-top: 16px;
  }

  > *:last-child {
    margin-right: 0;
  }
`;

export const HeadlineRow: React.FC = (props) => (
  <Row negativeMarginBottom {...props} />
);
